// Bug #92: Edge does not respect the duration parameter yet.
export var createTestAudioBufferSourceNodeStartMethodDurationParameterSupport = function createTestAudioBufferSourceNodeStartMethodDurationParameterSupport(nativeOfflineAudioContextConstructor) {
  return function () {
    if (nativeOfflineAudioContextConstructor === null) {
      return Promise.resolve(false);
    }
    var offlineAudioContext = new nativeOfflineAudioContextConstructor(1, 1, 44100);
    var audioBuffer = offlineAudioContext.createBuffer(1, 1, offlineAudioContext.sampleRate);
    var audioBufferSourceNode = offlineAudioContext.createBufferSource();
    audioBuffer.getChannelData(0)[0] = 1;
    audioBufferSourceNode.buffer = audioBuffer;
    audioBufferSourceNode.start(0, 0, 0);
    audioBufferSourceNode.connect(offlineAudioContext.destination);
    // Bug #21: Safari does not support promises yet.
    return new Promise(function (resolve) {
      offlineAudioContext.oncomplete = function (_ref) {
        var renderedBuffer = _ref.renderedBuffer;
        // Bug #5: Safari does not support copyFromChannel().
        resolve(renderedBuffer.getChannelData(0)[0] === 0);
      };
      offlineAudioContext.startRendering();
    });
  };
};